import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    base: process.env.BASE_URL,
    routes: [
        // ======================
        // Blank Layout
        // ======================    
        {
            path: '',
            component: () => import('./layout/blank/Blank.vue'),
            // ======================
            // Theme routes / pages
            // ======================
            children: [{
                path: '/',
                redirect: '/login',
                meta: { requiresVisitor: true }
            }, {
                path: '/login',
                name: 'Login',
                index: 1,
                component: () => import('./views/authentication/Login.vue'),
                meta: { requiresVisitor: true }
            }, {
                path: '/error404',
                name: 'Error 404',
                index: 2,
                component: () => import('./views/authentication/Error404.vue')
            }]
        },
        {
            // ======================
            // Full Layout
            // ======================
            path: '',
            component: () => import('./layout/full/MainContainer.vue'),
            // ======================
            // Theme routes / pages
            // ======================
            children: [{
                path: '/dashboards/classic-dashboard',
                name: 'Dashboard',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/dashboards/classic-dashboard'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/dashboards/classic-dashboard/ClassicDashboard.vue')
            }, {
                path: '/master/produk',
                name: 'produklist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Product',
                        url: '/master/product'
                    },
                    {
                        title: 'Product',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/produk/List.vue')
            },{
                path: '/master/produk/input',
                name: 'produkinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Product',
                        url: '/master/product'
                    },
                    {
                        title: 'Product',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/produk/Input.vue')
            },{
                path: '/master/produk/edit/:ref',
                name: 'produkedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Produk',
                        url: '/master/produk/edit/:ref'
                    },
                    {
                        title: 'Produk',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/produk/Input.vue')
            },{
                path: '/master/droppoint',
                name: 'dpointlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/dpoint/List.vue')
            },{
                path: '/master/droppoint/input',
                name: 'dpointinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/dpoint/Input.vue')
            },{
                path: '/master/droppoint/edit/:ref',
                name: 'dpointkedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan/edit/:ref'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/dpoint/Input.vue')
            },{
                path: '/master/branch',
                name: 'branchlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/branch/List.vue')
            },{
                path: '/master/branch/input',
                name: 'branchinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/branch/Input.vue')
            },{
                path: '/master/branch/edit/:ref',
                name: 'dpointkedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan/edit/:ref'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/branch/Input.vue')
            },{
                path: '/master/corporate',
                name: 'corporatelist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Corporate',
                        url: '/master/corporate'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/corporate/List.vue')
            },{
                path: '/master/corporate/input',
                name: 'corporateinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Corporate',
                        url: '/master/corporate'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/corporate/Input.vue')
            },{
                path: '/master/corporate/edit/:ref',
                name: 'agenedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/corporate/edit/:ref'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/corporate/Input.vue')
            },{
                path: '/master/gerai',
                name: 'gerailist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Gerai',
                        url: '/master/gerai'
                    },
                    {
                        title: 'Gerai',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/gerai/List.vue')
            },{
                path: '/master/gerai/input',
                name: 'geraiinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Gerai',
                        url: '/master/gerai'
                    },
                    {
                        title: 'Gerai',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/gerai/Input.vue')
            },{
                path: '/master/gerai/edit/:ref',
                name: 'geraiedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Gerai',
                        url: '/master/gerai/edit/:ref'
                    },
                    {
                        title: 'Gerai',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/gerai/Input.vue')
            },{
                path: '/master/tarif',
                name: 'tariflist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/tarif/List.vue')
            },{
                path: '/master/tarif/input',
                name: 'tarifinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/tarif/Input.vue')
            },{
                path: '/master/tarif/edit/:ref',
                name: 'tarifedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan/edit/:ref'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/tarif/Input.vue')
            },{
                path: '/trans/kirim',
                name: 'kirimlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/trans/kirim/List.vue')
            },{
                path: '/trans/kirim/input',
                name: 'kiriminput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/trans/kirim/Input.vue')
            },{
                path: '/trans/kirim/edit/:ref',
                name: 'kirimedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan/edit/:ref'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/trans/kirim/Input.vue')
            },{
                path: '/trans/kirimc',
                name: 'kirimclist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/trans/kirimCorp/List.vue')
            },{
                path: '/trans/kirimc/input',
                name: 'kirimcinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/trans/kirimCorp/Input.vue')
            },{
                path: '/trans/kirimc/edit/:ref',
                name: 'kirimcedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan/edit/:ref'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/trans/kirim/Input.vue')
            },{
                path: '/trans/manifest',
                name: 'manifestlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/manifest'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/trans/kirim/ListManifest.vue')
            },{
                path: '/operation/kirim',
                name: 'oprkirimlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/operation/kirim/List.vue')
            },{
                path: '/operation/terimagerai',
                name: 'terimagerailist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/operation/terimagerai/Input.vue')
            },{
                path: '/operation/sortir',
                name: 'sortirlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/operation/sortir/List.vue')
            },{
                path: '/operation/sortir/input',
                name: 'sortirinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Sortir Barang',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/operation/sortir/Input.vue')
            },{
                path: '/operation/transit',
                name: 'transitlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/operation/transit/Input.vue')
            },{
                path: '/operation/kurirbarang',
                name: 'kurirbarang',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Drop Point',
                        url: '/master/droppoint'
                    },
                    {
                        title: 'Drop Point',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/operation/kurirbarang/Input.vue')
            },{
                path: '/master/rekanan',
                name: 'rekananlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Rekanan',
                        url: '/master/rekanan'
                    },
                    {
                        title: 'Rekanan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/rekanan/List.vue')
            },{
                path: '/master/rekanan/input',
                name: 'rekananinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Rekanan',
                        url: '/master/rekanan'
                    },
                    {
                        title: 'Rekanan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/rekanan/Input.vue')
            },{
                path: '/master/rekanan/edit/:ref',
                name: 'rekananedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Rekanan',
                        url: '/master/rekanan/edit/:ref'
                    },
                    {
                        title: 'Rekanan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/rekanan/Input.vue')
            },{
                path: '/master/inventory',
                name: 'inventorylist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Inventory',
                        url: '/master/inventory'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/inventory/List.vue')
            },{
                path: '/master/inventory/input',
                name: 'inventoryinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Inventory',
                        url: '/master/inventory'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/inventory/Input.vue')
            },{
                path: '/master/inventory/edit/:ref',
                name: 'inventoryedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Inventory',
                        url: '/master/inventory/edit/:ref'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/inventory/Input.vue')
            },{
                path: '/master/perkiraan',
                name: 'perkiraanlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Perkiraan',
                        url: '/master/perkiraan'
                    },
                    {
                        title: 'Perkiraan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/perkiraan/List.vue')
            },{
                path: '/master/perkiraan/input',
                name: 'perkiraaninput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Perkiraan',
                        url: '/master/perkiraan'
                    },
                    {
                        title: 'Perkiraan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/perkiraan/Input.vue')
            },{
                path: '/master/perkiraan/edit/:ref',
                name: 'perkiraanedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Perkiraan',
                        url: '/master/perkiraan/edit/:ref'
                    },
                    {
                        title: 'Perkiraan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/perkiraan/Input.vue')
            },{
                path: '/master/role',
                name: 'rolelist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/role'
                    },
                    {
                        title: 'Role',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/role/List.vue')
            },{
                path: '/master/role/input',
                name: 'roleinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/role'
                    },
                    {
                        title: 'Role',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/role/Input.vue')
            },{
                path: '/master/role/edit/:ref',
                name: 'roleedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/role/edit/:ref'
                    },
                    {
                        title: 'Role',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/role/Input.vue')
            },{
                path: '/master/user',
                name: 'userlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'User',
                        url: '/master/user'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/user/List.vue')
            },{
                path: '/master/user/input',
                name: 'userinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'User',
                        url: '/master/user'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/user/Input.vue')
            },{
                path: '/master/user/:ref',
                name: 'useredit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/user/edit/:ref'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/user/Input.vue')
            },{
                path: '/master/kurir',
                name: 'kurirlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Kurir',
                        url: '/master/kurir'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/kurir/List.vue')
            },{
                path: '/master/kurir/input',
                name: 'kuririnput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Kurir',
                        url: '/master/kurir'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/kurir/Input.vue')
            },{
                path: '/master/kurir/:ref',
                name: 'kuriredit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/kurir/edit/:ref'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/kurir/Input.vue')
            },{
                path: '/master/parameter',
                name: 'parameterlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Kurir',
                        url: '/master/parameter'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/parameter/List.vue')
            },{
                path: '/master/parameter/:ref',
                name: 'parameteredit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/parameter/edit/:ref'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/parameter/Input.vue')
            },
            {
                path: '/report/index',
                name: 'report',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Laporan',
                        url: '/report/index'
                    },
                    {
                        title: 'Laporan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/report/Index.vue')
            },       
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/Error404'
        }
    ]
})

import NProgress from 'nprogress';

function isloggedIn(){
    return store.getters.getLoggedin;
}

/*router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!isloggedIn()) {
        next({
            name: 'Login'
        })
        } else {
        next()
        }
    } else if (to.matched.some(record => record.meta.requiresVisitor)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (isloggedIn()) {
        next({
            name: 'Dashboard'
        })
        } else {
        next()
        }
    } else {
        next() // make sure to always call next()!
    }
})*/

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        NProgress.start()
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!isloggedIn()) {
        next({
            name: 'Login'
        })
        } else {
        next()
        }
    } else if (to.matched.some(record => record.meta.requiresVisitor)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (isloggedIn()) {
        next({
            name: 'Dashboard'
        })
        } else {
        next()
        }
    } 
    next()
})

router.afterEach(() => {
    // Complete the animation of the route progress bar.
    NProgress.done()
})
export default router